<template>
  <footer class="w-full mt-16 text-center animate-fade-in-up" style="animation-delay: 0.5s">
    <p class="font-inter text-sm text-gray-600">@loginov-kirill &copy; 2024</p>
    <div class="mt-4 flex justify-center space-x-6">
      <a href="https://x.com/solotounicorn" class="social-icon" title="Twitter">
        <i class="fab fa-twitter"></i>
      </a>
      <a href="https://github.com/loginov-kirill/" class="social-icon github-icon animate-github-bounce-on-load" title="GitHub">
        <i class="fab fa-github"></i>
      </a>
      <a href="https://www.linkedin.com/in/loginov-kirill/" class="social-icon" title="LinkedIn">
        <i class="fab fa-linkedin"></i>
      </a>
      <a href="mailto:k.loginov.dev@gmail.com" class="social-icon" title="Email">
        <i class="fas fa-envelope"></i>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
}
</script>